

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import NotificationService from "services/NotificationService";

let initialState = { list: [] };

export const getNotifications = createAsyncThunk(
    "adminNotification/getNotifications",
    async () => {
        const response = await NotificationService.getNotifications();
        return response?.results;
    }
);


export const readNotifications = createAsyncThunk(
    "adminNotification/readNotifications",
    async (body) => {
        const response = await NotificationService.readNotifications(body);
        return response?.results;
    }
);


export const trashNotifications = createAsyncThunk(
    "adminNotification/trashNotifications",
    async (body) => {
        const response = await NotificationService.trashNotifications(body);
        return response?.results;
    }
);

const adminNotificationSlice = createSlice({
    name: "adminNotification",
    initialState: LoadingAdapter.getInitialState(initialState),
    reducers: {

    },
    extraReducers: (builder) => {
        LoadingAdapter.applyAsyncBuilder(getNotifications, builder, ["list"]);
    },
});

export default adminNotificationSlice.reducer;


export const selectUnReadNotification = (state) => state.adminNotification.list.filter(x => !x.isRead);